import { Common } from '@stockbit/ui';
import React from 'react';
import { HeaderContainer } from './styled';
import { Skeleton } from 'antd';

const { Text } = Common;

interface HeaderProps {
  title: string;
  children: React.ReactNode;
  isLoading?: boolean;
}

const Header = ({ title, children, isLoading = false }: HeaderProps) => (
  <HeaderContainer>
    {isLoading ? (
      <Skeleton.Button active size="small" style={{ width: '125px' }} />
    ) : (
      <Text size="16px" family="bold" ellipsis>
        {title}
      </Text>
    )}
    {children}
  </HeaderContainer>
);

export default Header;
